module.exports = __webpack_public_path__ + "static/img/contact.b22d338a.png";